import { useEffect, useState } from 'react';
import { getCurrentImageFromSearchParams } from 'shared/components/imageGallery/ImageGallery';

export const useInitialImageIndex = (): number => {
    const [initialImage, setInitialImage] = useState(0);

    useEffect(() => {
        try {
            const ci = getCurrentImageFromSearchParams(new URLSearchParams(window.location.search));
            setInitialImage(Number.isFinite(ci) ? ci : 0);
        } catch {
            setInitialImage(0);
        }
    }, []);

    return initialImage;
};
